/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EnergyConsumptionProductionTotal } from './energyConsumptionProductionTotal';


export interface StatusCodeValueEnergyConsumptionProductionTotal { 
    value?: EnergyConsumptionProductionTotal;
    status_code?: number;
}

